import { createRouter, createWebHistory } from 'vue-router'

import { installChunkReload } from './chunkReload'
import { installNavigationGuards } from './guards'
import { routes } from './routes'

export const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior: (to, from, savedPosition) => savedPosition ?? (to.path === from.path ? false : { top: 0 }),
})

installChunkReload(router)
installNavigationGuards(router)
